<div *ngIf="!auth.isLoggedIn()" class="text-center mt-3">
  <h4>You not are logged in.</h4>
  <p>Please login to view this page.</p>
  <button type="button" class="btn btn-primary" (click)="navService.showLogin()">Login</button>
</div>

<main id="orgAdmin" role="main" *ngIf="initialized">
  <nav class="navbar navbar-expand navbar-dark paper-review" style="background-color: #2e3f50">
    <a class="navbar-brand" [routerLink]="['/']">
      <img style="width: 30px" src="../../../assets/svg/circle-icon.svg" />
    </a>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item"></li>
        <li class="nav-item fullHeight" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['my-papers']">My Papers</a>
        </li>
        <li class="nav-item fullHeight" [routerLinkActive]="['active']">
          <a class="nav-link" [routerLink]="['all-papers']">All Papers </a>
        </li>
      </ul>
      <ul class="navbar-nav my-0 my-lg-0">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle d-none d-md-block" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ organization.name }}
          </a>
          <a class="nav-link dropdown-toggle d-block d-md-none" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-user-circle"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
            <div class="text-muted pl-2 pr-2">
              <img class="avatar u-sm-avatar rounded-circle mr-2" src="fetch-avatar?userId={{ auth.user.id }}&width=32&height=32&mode=crop"  />
              {{ auth.user.firstName }} {{ auth.user.lastName }}
            </div>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" [routerLink]="['/account/profile']">My Account</a>
            <a class="dropdown-item" [routerLink]="['/account/ceus']">CEU History</a>
            <a class="dropdown-item" [routerLink]="['my-events']">My Presentations</a>
            <div *ngIf="auth && auth.isSuperUser()" class="dropdown-divider"></div>
            <a *ngIf="auth && auth.isSuperUser()" class="dropdown-item" [routerLink]="['/super-user']">Super User</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" [routerLink]="[]" (click)="logout()">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>

  <div class="container-fluid">
    <h5>{{ conference.name }} Paper Review</h5>
    <router-outlet></router-outlet>
  </div>
</main>
